import { ReactNode } from 'react';

import { Typography } from '../../Typography';
import { Button } from '../../Button';
import { Snackbar } from '../../Snackbar';
import { useIsDesktop, useIsMobile } from '../../hooks';

/**
 * Свойства компонента {@link PreviewSnackbar}
 */
interface PreviewSnackbarProps {
  /**
   * Флаг, указывающий, открыт ли Snackbar.
   */
  open: boolean;

  /**
   * Функция, вызываемая при нажатии на кнопку в Snackbar.
   */
  onClick: () => void;

  /**
   * Сообщение для отображения в Snackbar.
   */
  message: ReactNode | ReactNode[];

  /**
   * Действие для отображения в Snackbar (например, кнопка).
   */
  action: ReactNode | ReactNode[];
}

/**
 * Компонент Snackbar для предварительного просмотра файла.
 *
 * @internal
 * @param open - Флаг, указывающий, открыт ли Snackbar.
 * @param onClick - Функция, вызываемая при нажатии на кнопку в Snackbar.
 * @param message - Сообщение для отображения в Snackbar.
 * @param action - Действие для отображения в Snackbar (например, кнопка).
 * @returns  Возвращает элемент React с Snackbar для просмотра файла.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link PreviewSnackbarProps}
 */
export const PreviewSnackbar = ({
  open,
  onClick,
  action,
  message,
}: PreviewSnackbarProps) => {
  const isDesktop = useIsDesktop();
  const isMobile = useIsMobile();

  return (
    <>
      {isMobile && message && (
        <Snackbar
          open={open}
          message={
            <Typography variant="subtitle1" color="text.dark.primary">
              {message}
            </Typography>
          }
          action={null}
          zPosition="top"
        />
      )}
      <Snackbar
        open={open}
        message={
          !isMobile && (
            <Typography variant="h6" color="text.dark.primary">
              {message}
            </Typography>
          )
        }
        action={
          <Button
            onClick={onClick}
            size={isMobile ? 'medium' : 'large'}
            fullWidth={isMobile}
          >
            {action || 'Закрыть'}
          </Button>
        }
        className="aqa_file_preview_snackbar"
        variant={isDesktop ? 'static' : 'sticky'}
        zPosition="bottom"
      />
    </>
  );
};
